export enum GameInstanceStatuses
{
  Pending = 1,
  Active = 2,
  ReadyForDraw = 3,
  Drawn = 4,
  WinnerAnnounced = 5,
  EndedWithoutPlayers = 6
}
